import { EditorState } from "@codemirror/state";
import { EditorView } from "@codemirror/view";
import { generalSetup } from "./editorSetup.js";
import * as highlightLines from "./highlightLines.js";
import "./CulpritPatternHighlighting.js";
import "./ConditionalFlow.js";

const editorInstances: EditorView[] = [];

function createEditor(
  parent: HTMLElement,
  source: string,
  lineRanges: highlightLines.LineRange[]
) {
  return new EditorView({
    parent,
    state: EditorState.create({
      doc: source,
      extensions: [
        generalSetup,
        highlightLines.facet.of(lineRanges),
        highlightLines.viewPlugin,
      ],
    }),
  });
}

function setupEditor(pre: HTMLPreElement) {
  const source = pre.textContent;
  if (typeof source !== "string") return null;
  const lineRanges =
    pre.dataset.highlightLines === undefined
      ? []
      : highlightLines.parse(pre.dataset.highlightLines);
  console.log(lineRanges);
  const container = document.createElement("div");
  container.classList.add("code-block");
  pre.replaceWith(container);
  return createEditor(container, source, lineRanges);
}

document.querySelectorAll("pre.code-block").forEach((pre) => {
  if (!(pre instanceof HTMLPreElement)) return;
  const editor = setupEditor(pre);
  if (editor) editorInstances.push(editor);
});
